export const CURRENCY = {
  CANDY: 'candy',
  FUEL: 'fuel'
};

export const RARITY = {
  RARE: 0,
  UNCOMMON: 1,
  COMMON: 2,
};

export const TYPE = {
  CHARACTER: 0,
  ITEM: 1,
  ENERGY: 2
};

export const ENERGY = {
  CANDY: 'candy',
  LANTERN: 'lantern'
};

export const characters = [
  {
    name: "Wirt",
    type: TYPE.CHARACTER,
    number: 1,
    health: 30,
    image: require('./images/wirt-crop.png'),
    rarity: RARITY.RARE,
    move: {
      title: 'Pessimism',
      description: 'Take 10 damage to yourself, to deal 30',
      cost: {
        type: CURRENCY.CANDY,
        amount: 2
      }
    }
  },
  {
    name: "Greg",
    type: TYPE.CHARACTER,
    number: 2,
    health: 20,
    image: require('./images/greg.png'),
    rarity: RARITY.RARE,
    move: {
      title: 'Candy Camouflage',
      description: 'Add 2 candy energys to your hand',
    }
  },
  {
    name: "Beatrice",
    type: TYPE.CHARACTER,
    number: 3,
    health: 30,
    image: require('./images/beatrice.png'),
    rarity: RARITY.RARE,
    move: {
      title: 'Deception',
      description: 'Give 10 health to a character',
      cost: {
        type: CURRENCY.CANDY,
        amount: 1
      }
    }
  },
  {
    name: "Woodsman",
    type: TYPE.CHARACTER,
    number: 4,
    health: 40,
    image: require('./images/woodsman.png'),
    rarity: RARITY.RARE,
    move: {
      title: 'Wood Chop',
      description: 'Deal 15 damage',
      cost: {
        type: CURRENCY.CANDY,
        amount: 1
      }
    }
  },
  {
    name: "The Beast",
    type: TYPE.CHARACTER,
    number: 5,
    health: 50,
    image: require('./images/beast.png'),
    rarity: RARITY.RARE,
    move: {
      title: 'Petrify',
      description: 'Scare one opponent\'s card back into hand',
      cost: {
        type: CURRENCY.FUEL,
        amount: 2
      }
    }
  },
  {
    name: "Enoch",
    type: TYPE.CHARACTER,
    number: 6,
    "health": 50,
    "image": require('./images/enoch.png'),
    "rarity": RARITY.UNCOMMON,
    "move": {
      "title": "Punish",
      "description": "Deal 5 damage to all opponents",
      "cost": {
        "type": CURRENCY.FUEL,
        "amount": 1
      }
    }
  },
  {
    name: "Sara",
    type: TYPE.CHARACTER,
    number: 7,
    "health": 30,
    "image": require('./images/sara.png'),
    "rarity": RARITY.UNCOMMON,
    "move": {
      "title": "Cheer",
      "description": "All allied characters do 2x damage"
    }
  },
  {
    name: "Jason Funderburker",
    type: TYPE.CHARACTER,
    number: 8,
    "subname": "(frog)",
    "health": 15,
    "image": require('./images/jason-frog.png'),
    "rarity": RARITY.UNCOMMON,
    "move": {
      "title": "Sing",
      "description": "Send an opponent to sleep",
      "cost": {
        "type": CURRENCY.CANDY,
        "amount": 1
      }
    }
  },
  {
    name: "Jason Funderburker",
    type: TYPE.CHARACTER,
    number: 9,
    "subname": "(human)",
    "health": 15,
    "image": require('./images/jason-human.png'),
    "rarity": RARITY.UNCOMMON,
    "move": {
      "title": "Fashion Sense",
      "description": "Draw a card and add it to your hand"
    }
  },
  {
    name: "Lorna",
    type: TYPE.CHARACTER,
    number: 10,
    "health": 20,
    "image": require('./images/lorna.png'),
    "rarity": RARITY.COMMON,
    "move": {
      "title": "Sweep up",
      "description": "Kill any opposition with 5 or less health",
      "cost": {
        "type": CURRENCY.CANDY,
        "amount": 1
      }
    }
  },
  {
    name: "Auntie Whispers",
    type: TYPE.CHARACTER,
    number: 11,
    "health": 20,
    "image": require('./images/auntie-whispers.png'),
    "rarity": RARITY.COMMON,
    "move": {
      "title": "Devour",
      "description": "Deal 15 damage",
      "cost": {
        "type": CURRENCY.FUEL,
        "amount": 2
      }
    }
  },
  {
    name: "Adelaide",
    type: TYPE.CHARACTER,
    number: 12,
    "health": 20,
    "image": require('./images/adelaide.png'),
    "rarity": RARITY.COMMON,
    "move": {
      "title": "Child Labour",
      "description": "Add 2 lantern fuel to your hand"
    }
  },
  {
    name: "Quincy Endicott",
    type: TYPE.CHARACTER,
    number: 13,
    "health": 25,
    "image": require('./images/quincy.png'),
    "rarity": RARITY.COMMON,
    "move": {
      "title": "Infatuation",
      "description": "Deal 5 damage to single opponent over 3 turns",
      "cost": {
        "type": CURRENCY.CANDY,
        "amount": 1
      }
    }
  },
  {
    name: "Margueritte Grey",
    type: TYPE.CHARACTER,
    number: 14,
    "health": 25,
    "image": require('./images/margueritte.png'),
    "rarity": RARITY.COMMON,
    "move": {
      "title": "Apparition",
      "description": "Choose a character to skip a turn"
    }
  },
  {
    name: "Miss Langtree",
    type: TYPE.CHARACTER,
    number: 15,
    "health": 30,
    "image": require('./images/miss-langtree.png'),
    "rarity": RARITY.COMMON,
    "move": {
      "title": "Inspire",
      "description": "Add 5 health to 2 characters",
      "cost": {
        "type": CURRENCY.CANDY,
        "amount": 1
      }
    }
  },
  {
    name: "The Highwayman",
    type: TYPE.CHARACTER,
    number: 16,
    "health": 40,
    "image": require('./images/the-highwayman.png'),
    "rarity": RARITY.COMMON,
    "move": {
      "title": "Steal",
      "description": "Steal 2 energy cards",
      "cost": {
        "type": CURRENCY.FUEL,
        "amount": 1
      }
    }
  },
  {
    "number": 17,
    "name": "Rock Fact",
    "image": require('./images/rock-fact.png'),
    "rarity": RARITY.RARE,
    "type": TYPE.ITEM,
    "move": {
      "description": "Draw another card into your hand"
    }
  },
  {
    "number": 18,
    "name": "Animals",
    "image": require('./images/animals.png'),
    "rarity": RARITY.RARE,
    "type": TYPE.ITEM,
    "move": {
      "description": "Take 1 candy and 1 fuel lantern card"
    }
  },
  {
    "number": 19,
    "name": "Ol' Windbag",
    "image": require('./images/ol-windbag.png'),
    "rarity": RARITY.RARE,
    "type": TYPE.ITEM,
    "move": {
      "description": "Send an opponent back into their hand"
    }
  },
  {
    "number": 20,
    "name": "Cassette Tape",
    "image": require('./images/cassette.png'),
    "rarity": RARITY.UNCOMMON,
    "type": TYPE.ITEM,
    "move": {
      "description": "Force an opponent to do a move next turn"
    }
  },
  {
    "number": 21,
    "name": "Halloween kids",
    "image": require('./images/halloween-kids.png'),
    "rarity": RARITY.UNCOMMON,
    "type": TYPE.ITEM,
    "move": {
      "description": "Restore 10 health to a character"
    }
  },
  {
    "number": 22,
    "name": "The beasts eyes",
    "image": require('./images/beast-eyes.png'),
    "rarity": RARITY.UNCOMMON,
    "type": TYPE.ITEM,
    "move": {
      "description": "Allow a character to do another move"
    }
  },
  {
    "number": 23,
    "name": "Pumpkin People",
    "image": require('./images/pumpkin-people.png'),
    "rarity": RARITY.COMMON,
    "type": TYPE.ITEM,
    "move": {
      "description": "Resurrect one dead character"
    }
  },
  {
    "number": 24,
    "name": ENERGY.CANDY,
    "image": require('./images/energy-candy.png'),
    "rarity": RARITY.COMMON,
    "type": TYPE.ENERGY,
  },
  {
    "number": 25,
    "name": ENERGY.LANTERN,
    "image": require('./images/energy-lantern.png'),
    "rarity": RARITY.COMMON,
    "type": TYPE.ENERGY,
  }
];
